// @flow
import { combineReducers } from "redux";

import Layout from "./layout/reducers";

export default combineReducers({
  Layout,
});
